import React from 'react';

const SkeletonBlock = ({ className }) => (
  <div className={`bg-gray-200 rounded-md ${className}`}></div>
);

const HomePageSkeleton = () => {
  return (
    <div className="container mx-auto py-8 animate-pulse">
      <div className="flex flex-col lg:flex-row gap-8">
        {/* --- Columna Principal (Izquierda) --- */}
        <div className="w-full lg:w-2/3 space-y-6">
          {/* Video Destacado */}
          <SkeletonBlock className="h-96 w-full" />

          {/* Banner de Anuncio */}
          <SkeletonBlock className="h-24 w-full" />

          {/* Sección de Top Stories */}
          <div>
            <SkeletonBlock className="h-8 w-1/3 mb-4" />
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="space-y-2">
                <SkeletonBlock className="h-40 w-full" />
                <SkeletonBlock className="h-6 w-5/6" />
                <SkeletonBlock className="h-4 w-3/4" />
              </div>
              <div className="space-y-2">
                <SkeletonBlock className="h-40 w-full" />
                <SkeletonBlock className="h-6 w-5/6" />
                <SkeletonBlock className="h-4 w-3/4" />
              </div>
            </div>
          </div>
        </div>

        {/* --- Barra Lateral (Derecha) --- */}
        <aside className="w-full lg:w-1/3">
          <div className="sticky top-24 space-y-8">
            {/* Widget de Búsqueda */}
            <SkeletonBlock className="h-12 w-full" />
            {/* Widget del Clima */}
            <SkeletonBlock className="h-32 w-full" />
            {/* Widget de Categorías */}
            <div className="space-y-3">
              <SkeletonBlock className="h-6 w-1/2" />
              {[...Array(5)].map((_, i) => (
                <SkeletonBlock key={i} className="h-8 w-full" />
              ))}
            </div>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default HomePageSkeleton;
